<div class="fixed top-0 left-0 right-0 bottom-0 bg-white z-200 flex flex-col items-center justify-center">
    <span class="h-[350px]"><span
            class="flex flex-row items-center gap-1 w-full max-w-3xl border-b-2 border-b-[#C7C8CA] pb-5 mb-5">
            @if(isPackage(report())){
            <img src="assets/images/reports/Package.png" class="max-w-[35px]"
                appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async"
                alt="{{ report().name }}" />
            }@else {
            <img src="assets/images/reports/{{ report().id }}.png" class="max-w-[35px]"
                appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async"
                alt="{{ report().name }}" />
            }
            <span class="text-2xl text-black p-1 text-ellipsis text-nowrap overflow-hidden">{{
                report().name }}</span></span>
        <span class="w-full max-w-3xl flex flex-row gap-3">
            <span class="flex flex-col gap-3">
                <span class="text-xl text-[#545454] font-light">
                    Language
                </span>
                <mat-form-field>
                    <mat-select [value]="selectedLanguage()" (selectionChange)="onLanguageChange($event.value)">
                        <mat-option [value]="report().language">{{ report().language | localeName}}</mat-option>

                        @for (lang of languages(); track $index) {
                        <mat-option [value]="lang">{{ lang | localeName}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </span>
            <span class="flex flex-col gap-3">
                <span class="text-lg text-[#545454] font-light">
                    Norm
                </span>
                <mat-form-field>
                    <mat-select [value]="selectedNorm()" (selectionChange)="onNormChange($event.value)">
                        <mat-option [value]="report().norm">{{ report().norm }}</mat-option>

                        @for (norm of norms(); track $index) {
                        <mat-option [value]="norm">{{ norm }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </span>
            @if (report().jobProfile !== null) {
            <span class="flex flex-col gap-3">
                <span class="text-lg text-[#545454] font-light">
                    Job profile
                </span>
                <mat-form-field>
                    <mat-select [value]="selectedJobProfile()" (selectionChange)="selectedJobProfile.set($event.value)">
                        <mat-option [value]="report().jobProfile">{{ report().jobProfile }}</mat-option>

                        @if (jobProfiles()) {
                        @for (jp of jobProfiles()!; track $index) {
                        <mat-option [value]="jp">{{ jp }}</mat-option>
                        }
                        }
                    </mat-select>
                </mat-form-field>
            </span>
            }
        </span>
        @if (languageOrNormChanged()) {
        <span class="w-full max-w-3xl flex flex-col gap-3 bg-[#D6EEF5] p-4 mb-4 rounded">
            <span class="text-[#3C7B91]" i18n>
                Saving changes will only impact participant reports that have not generated.
            </span>
            <span>
                <button matButton="filled" class="bg-[#3FB6D3]! text-white!" (click)="save(true)"
                    [disabled]="isSubmitting()" i18n>Update All Reports</button>
            </span>
        </span>
        }
        <span class="w-full max-w-3xl">
            <span class="flex flex-row items-center gap-3">
                <button matButton="filled" (click)="save()" [disabled]="isSubmitting()">Save</button>
                <a matButton="filled" routerLink="../..">Cancel</a></span>
        </span></span>
</div>